const { DEVICE_STATUS } = require('../../constants/devices/deviceStatuses')
const { fields } = require('cloud-utils/config/device-settings/default-v2.json')
const lodash = require('lodash')
const SemVerGte = require('semver/functions/gte')
const browserInfo = require('../../js/single_webrtc').getBrowserInfo()
const recordingEncryptionField = fields.find(
  ({ name }) => name === 'recordingEncryption'
)
const deviceEventSettings = window.filterEnvironmentDeviceSettings(
  require('cloud-utils/config/events/default.json').deviceEventSettings
)

angular.module('surfsightApp.controllers').controller('edgeListController', [
  '$scope',
  '$rootScope',
  '$state',
  '$stateParams',
  '$timeout',
  '$interval',
  '$location',
  '$window',
  '$http',
  '$q',
  '$filter',
  '$localStorage',
  '$mdDialog',
  '$mdSidenav',
  '$mdToast',
  '$mdColors',
  '$mdMedia',
  'edgeFactoryV2',
  'edgeGroupFactoryV2',
  'broadcastViewFactory',
  'leafletData',
  'leafletBoundsHelpers',
  'nominatimLookUp',
  '$translate',
  function (
    $scope,
    $rootScope,
    $state,
    $stateParams,
    $timeout,
    $interval,
    $location,
    $window,
    $http,
    $q,
    $filter,
    $localStorage,
    $mdDialog,
    $mdSidenav,
    $mdToast,
    $mdColors,
    $mdMedia,
    edgeFactoryV2,
    edgeGroupFactoryV2,
    broadcastViewFactory,
    leafletData,
    leafletBoundsHelpers,
    nominatimLookUp,
    $translate1
  ) {
    $scope.DEVICE_STATUS = DEVICE_STATUS

    const $translate = $filter('translate')
    let searchTextTimer
    $scope.trackSearchText = () => {
      searchTextTimer && $timeout.cancel(searchTextTimer)
      searchTextTimer = $timeout(() => {
        $scope.deviceSearchState.highlightText =
          $scope.deviceSearchState.searchText
        requestGroupPagination(true) // load devices with default pagination
      }, 1500)
    }
    $scope.deviceSearchState = {
      searchText: '',
      highlightText: '',
      groupPaginations: {}
    }
    const clearGroupDevices = groupId => {
      const previousDevices = edgeFactoryV2.list.filter(
        device => device.groupId === groupId
      )
      previousDevices.forEach(device => {
        edgeFactoryV2.deleteItemByImei(device.imei)
      })
    }
    const requestGroupPagination = (
      allGroups = true,
      groupId = false,
      page = 1,
      limit = 200,
      offset = 0
    ) => {
      const { searchText } = $scope.deviceSearchState
      if (allGroups) {
        edgeGroupFactoryV2.list.forEach(edgeGroup => {
          clearGroupDevices(edgeGroup.id)
          edgeGroup.opened = !!searchText || edgeGroup.id === -1
        })
      }
      const requestEdgeGroups = edgeGroupFactoryV2.list.filter(
        edgeGroup =>
          (allGroups && (searchText || edgeGroup.id === -1)) ||
          edgeGroup.id === groupId
      )
      const groupPaginations = requestEdgeGroups.map(edgeGroup => ({
        groupId: edgeGroup.id,
        limit,
        offset
      }))
      requestEdgeGroups.forEach(edgeGroup => {
        edgeGroup.opened = edgeGroup.opened || allGroups
        $scope.deviceSearchState.groupPaginations[edgeGroup.id] = {
          loading: true,
          page,
          offset,
          dashcams: [],
          totalCount: 0
        }
      })

      const requests = groupPaginations.map(({ groupId }) => {
        const params =
          offset == 0
            ? {
                groupId,
                limit,
                name: $scope.deviceSearchState.searchText,
                getTelemetryData: false
              }
            : {
                groupId,
                limit,
                offset: offset,
                name: $scope.deviceSearchState.searchText,
                getTelemetryData: false
              }

        return $http({
          method: 'GET',
          url: `${V2_BASEURL}/organizations/${$rootScope.currentUserOrganization.id}/devices`,
          params: params,
          headers: {
            source: 'x-surfsight-internal'
          }
        }).then(result => {
          return {
            ...result,
            groupId
          }
        })
      })

      if (groupPaginations.length) {
        $q.all(requests)
          .then(responses => {
            responses.forEach(response => {
              const groupId = response.groupId
              const dashcams = response.data.data
              const totalCount = response.data.metadata.count
              const lastPage = Math.ceil(totalCount / limit)
              const startOfRecords = page === 1 ? 1 : (page - 1) * limit + 1
              const endOfRecords = page === lastPage ? totalCount : page * limit
              $scope.deviceSearchState.groupPaginations[groupId] = {
                loading: false,
                page,
                offset,
                limit,
                dashcams,
                totalCount,
                startOfRecords,
                endOfRecords,
                lastPage
              }
              clearGroupDevices(groupId)
              dashcams.forEach(device => {
                edgeFactoryV2.addOrUpdateItem(device)
              })

              if (allGroups && totalCount === 0) {
                const edgeGroup = edgeGroupFactoryV2.list.find(
                  e => e.groupId === groupId
                )
                if (edgeGroup) edgeGroup.opened = false
              }
              $scope.$emit('loadEdgesEvt', {})
            })
          })
          .catch(error => {
            handleServerError(error)
            groupPaginations.forEach(({ groupId }) => {
              $scope.deviceSearchState.groupPaginations[groupId] = {
                loading: false,
                page,
                offset,
                limit,
                dashcams: [],
                totalCount: 0,
                startOfRecords: 0,
                endOfRecords: 0,
                lastPage: 0
              }
            })
          })
      }
    }
    requestGroupPagination()
    $scope.groupNavigation = (groupId, pageIndicator) => {
      const groupPagination = $scope.deviceSearchState.groupPaginations[groupId]
      if (!groupPagination) {
        return
      }
      const { page, offset, limit, totalCount } = groupPagination
      const lastPage = Math.ceil(totalCount / limit)
      let newPage
      let newOffset
      switch (pageIndicator) {
        case 'first':
          newPage = 1
          newOffset = 0
          break
        case 'previous':
          newPage = page === 1 ? 1 : page - 1
          newOffset = offset === 0 ? 0 : offset - limit
          break
        case 'next':
          newPage = page === lastPage ? lastPage : page + 1
          newOffset = offset + limit
          break
        case 'last':
          newPage = lastPage
          newOffset = limit * (lastPage - 1)
          break
        case 'current':
          newPage = page
          newOffset = offset
          break
        default:
          newPage = 1
          newOffset = 0
          break
      }
      if (newPage === page && pageIndicator !== 'current') {
        return
      }
      $scope.deviceSearchState.groupPaginations[groupId] = {
        ...groupPagination,
        page: newPage,
        offset: newOffset
      }
      requestGroupPagination(false, groupId, newPage, limit, newOffset)
    }
    $scope.edge_list_loading = false

    edgeFactoryV2.list.forEach(function (e, i) {
      e.opened = false
      edgeFactoryV2.addOrUpdateItem(e)
    })
    $scope.deviceListScrollbarOptions = {
      enable: $mdMedia('gt-sm'),
      autoHide: false
    }
    $scope.currentState = $state.current.name
    if ($scope.currentState === 'home.common.edge.list') {
      $timeout(function () {
        $scope.openSideNav('edge-list')
        if ($mdMedia('gt-sm')) {
          $scope.openSideNav('multiple-braodcast-videos')
        }
      })
    } else if ($scope.currentState === 'home.common.maps.view') {
      $timeout(function () {
        $scope.openSideNav('edge-list')
        if ($mdMedia('gt-sm')) {
          $scope.openSideNav('edges-map-sidenav')
        }
      }, 100)
    }
    $scope.bulkDevicesSelectionsState = {
      canShow:
        ['home.common.edge.list', 'home.common.events'].includes(
          $state.$current.name
        ) && $localStorage.userDetails.permission_role !== 'user',
      actions: {
        eventSettings: {
          show: $state.$current.name === 'home.common.events'
        },
        uiSettings: {
          show:
            $state.$current.name === 'home.common.edge.list' &&
            $localStorage.userDetails.permission_role !== 'user'
        }
      },
      show: false,
      bulkDevicesSelections: {
        groupIds: [],
        intermediateGroupIds: [],
        groups: [],
        serialNumbers: [],
        allExcludedSerialNumbers: [],
        devices: []
      }
    }
    const getMaxFirmwareversion = () => {
      const versionSorter = (q, w) => {
        if (q === w) return 0
        return SemVerGte(q, w) ? -1 : 1
      }
      if (
        $scope.bulkDevicesSelectionsState.bulkDevicesSelections.groupIds
          .length > 0
      ) {
        return [
          ...new Set(
            deviceEventSettings.map(a => a.fromVersion || '0.0.0')
          ).values()
        ]
          .sort(versionSorter)
          .shift()
      }
      const firmWareArr = $scope.bulkDevicesSelectionsState.bulkDevicesSelections.devices
        .map(e => (e.firmwareVersion ? e.firmwareVersion : '0.0.0'))
        .sort(versionSorter)
      return firmWareArr[0]
    }
    const getBulkDeviceSelections = () => {
      const {
        groups,
        serialNumbers,
        devices,
        groupIds
      } = $scope.bulkDevicesSelectionsState.bulkDevicesSelections
      return {
        groups,
        serialNumbers,
        devices,
        groupIds
      }
    }
    $scope.toggleGroupSelection = group => {
      const { id: groupId } = group
      const index = $scope.bulkDevicesSelectionsState.bulkDevicesSelections.groups.findIndex(
        g => g.groupId === groupId
      )
      if (index > -1) {
        $scope.bulkDevicesSelectionsState.bulkDevicesSelections.groups.splice(
          index,
          1
        )
      } else {
        $scope.bulkDevicesSelectionsState.bulkDevicesSelections.groups.push({
          groupId,
          organizationId: $localStorage.currentUserOrganization.id,
          excludeSerialNumbers: []
        })
      }
      $scope.bulkDevicesSelectionsState.bulkDevicesSelections.devices = $scope.bulkDevicesSelectionsState.bulkDevicesSelections.devices.filter(
        d => d.groupId !== groupId
      )
      refreshSelectionData()
    }
    $scope.toggleDeviceSelection = device => {
      const { imei, groupId } = device
      const index = $scope.bulkDevicesSelectionsState.bulkDevicesSelections.devices.findIndex(
        ({ imei: deviceImei }) => deviceImei === imei
      )
      if (index > -1) {
        $scope.bulkDevicesSelectionsState.bulkDevicesSelections.devices.splice(
          index,
          1
        )
      } else {
        const groupSelection = $scope.bulkDevicesSelectionsState.bulkDevicesSelections.groups.find(
          g => g.groupId === groupId
        )
        if (groupSelection) {
          const excludedSerialNumberIndex = groupSelection.excludeSerialNumbers.indexOf(
            imei
          )
          if (excludedSerialNumberIndex > -1) {
            groupSelection.excludeSerialNumbers.splice(
              excludedSerialNumberIndex,
              1
            )
          } else {
            groupSelection.excludeSerialNumbers.push(imei)
          }
        } else {
          $scope.bulkDevicesSelectionsState.bulkDevicesSelections.devices.push(
            device
          )
        }
      }
      refreshSelectionData()
    }
    const refreshSelectionData = () => {
      const serialNumbers = $scope.bulkDevicesSelectionsState.bulkDevicesSelections.devices.map(
        ({ imei }) => imei
      )
      const groupIds = $scope.bulkDevicesSelectionsState.bulkDevicesSelections.groups.map(
        ({ groupId }) => groupId
      )
      const intermediateGroupIds = [
        ...$scope.bulkDevicesSelectionsState.bulkDevicesSelections.groups
          .filter(({ excludeSerialNumbers }) => excludeSerialNumbers.length)
          .map(({ groupId }) => groupId),
        ...$scope.bulkDevicesSelectionsState.bulkDevicesSelections.devices.map(
          ({ groupId }) => groupId
        )
      ]

      $scope.bulkDevicesSelectionsState.bulkDevicesSelections.serialNumbers = serialNumbers
      $scope.bulkDevicesSelectionsState.bulkDevicesSelections.groupIds = groupIds
      $scope.bulkDevicesSelectionsState.bulkDevicesSelections.intermediateGroupIds = intermediateGroupIds
      $scope.bulkDevicesSelectionsState.bulkDevicesSelections.allExcludedSerialNumbers = $scope.bulkDevicesSelectionsState.bulkDevicesSelections.groups.reduce(
        (_allExcludedSerialNumbers, { excludeSerialNumbers }) => [
          ..._allExcludedSerialNumbers,
          ...excludeSerialNumbers
        ],
        []
      )
      $scope.bulkDevicesSelectionsState.show =
        serialNumbers.length + groupIds.length !== 0
    }
    const clearSelectionData = () => {
      $scope.bulkDevicesSelectionsState.bulkDevicesSelections.groups = []
      $scope.bulkDevicesSelectionsState.bulkDevicesSelections.devices = []
      refreshSelectionData()
    }
    $scope.$on('currentSideNavAddBtnReceive', function (e, data) {
      $scope.showEdgeModal(data)
    })

    const statusTimer = $interval(function () {
      const groupsIds = lodash.uniq(
        edgeFactoryV2.list.map(device => device.groupId)
      )

      edgeFactoryV2
        .getDevicesInGroups(
          $rootScope.currentUserOrganization.id,
          groupsIds,
          $scope.deviceSearchState.searchText
        )
        .then(devices => {
          Object.keys($scope.deviceSearchState.groupPaginations).forEach(
            groupKey => {
              $scope.deviceSearchState.groupPaginations[
                groupKey
              ].dashcams.forEach((dashcam, dashcamIndex) => {
                const updatedDevice = devices.find(
                  device =>
                    device.imei === dashcam.imei && device.groupId == groupKey
                )
                if (updatedDevice) {
                  $scope.deviceSearchState.groupPaginations[groupKey].dashcams[
                    dashcamIndex
                  ].status = updatedDevice.status
                  $scope.deviceSearchState.groupPaginations[groupKey].dashcams[
                    dashcamIndex
                  ].isSemiOnline = updatedDevice.isSemiOnline // can be undefined as well
                }
              })
            }
          )
        })
        .catch(error => $scope.$emit('handleServerError', error))
    }, 15000)

    $scope.$watch(
      () => {
        return edgeFactoryV2.list
      },
      (current, previous) => {
        $scope.edge_list = current
      }
    )
    $scope.sortBy = function (sort, order) {
      $scope.sortByName = sort
      $scope.orderBy = order
      $rootScope.selectedOrder = order === '' ? 'creationTime' : order
      loadEdgeGroups(true)
    }
    $scope.edge_groups = edgeGroupFactoryV2.list
    const loadEdgeGroups = (reset = false) => {
      if (!reset) {
        if (edgeGroupFactoryV2.list.length !== 0) {
          $scope.edge_groups = edgeGroupFactoryV2.list
          return
        }
      } else {
        edgeGroupFactoryV2.list.push({ id: -1, name: 'devices', opened: true })
      }
      $scope.edge_groups_loading = true
      edgeGroupFactoryV2
        .getGroups(
          $rootScope.currentUserOrganization.id,
          $scope.sortByName,
          $scope.orderBy
        )
        .then(
          function (response) {
            const groups = response.data.data || []
            edgeGroupFactoryV2.list = groups.map(e => {
              e.edges = []
              return e
            })
            $scope.edge_groups = edgeGroupFactoryV2.list
            $scope.edge_groups.push({
              id: -1,
              name: 'devices',
              opened: true,
              edges: []
            })
            $scope.edge_groups_loading = false
            requestGroupPagination(false, -1)
            $rootScope.edgeGroupsLoaded = true
          },
          function (response) {
            handleServerError(response)
            if (response.data && response.data.status) {
              showMessageToast(response.data.status.error)
            }
          }
        )
    }
    ;(!$rootScope.edgeGroupsLoaded || edgeGroupFactoryV2.list.length === 0) &&
      loadEdgeGroups(true)
    const redirectToGroupReports = groupId => {
      $state.go('home.common.reports.edgegroup', {
        edge_group_id: groupId
      })
    }
    $scope.collapseEdgeGroup = (
      group,
      selected_sideStripe_menu,
      expandOnly = false
    ) => {
      if (selected_sideStripe_menu === 5 && !expandOnly) {
        redirectToGroupReports(group.id)
      } else {
        group.opened = !group.opened
        edgeGroupFactoryV2.addOrUpdateItem(group)
        if (group.opened) {
          requestGroupPagination(false, group.id, 1)
        } else {
          // clear collapsed edge group devices
          const previousDevices = edgeFactoryV2.list.filter(
            device => device.groupId === group.id
          )
          previousDevices.forEach(device => {
            edgeFactoryV2.deleteItemByImei(device.imei)
          })
          $scope.$emit('loadEdgesEvt', {})
        }
      }
    }
    $scope.showEdgeModal = ev => {
      $mdDialog
        .show({
          locals: {
            dataFromCaller: {
              whitelabel: $rootScope.data.whitelabel
            }
          },
          controller: 'EdgeModalController',
          templateUrl:
            './templates/edge.modal.view.html?t=' + window.webpackHash,
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true // Only for -xs, -sm breakpoints.
        })
        .then(({ data }) => {
          if (data.type === 'edge') {
            const groupId = -1 // default group for unassigned edges
            $scope.groupNavigation(groupId, 'current')
          } else {
            loadGroupDetails(data)
          }
        })
    }
    $scope.confirmEdgeDelete = (ev, deviceId) => {
      // Appending dialog to document.body to cover sidenav in docs app
      const confirm = $mdDialog
        .confirm()
        .title($translate('areYouSureYouWantToDeleteThisEdge'))
        .textContent('')
        .ariaLabel($translate('deleteEdge'))
        .targetEvent(ev)
        .ok($translate('delete'))
        .cancel($translate('cancel'))

      $mdDialog.show(confirm).then(
        () => {
          edgeFactoryV2
            .deleteDevice($rootScope.currentUserOrganization.id, deviceId)
            .then(
              () => {
                loadEdgeGroups(true)
                leafletData.getMap().then(function (map) {
                  map.closePopup()
                })
              },
              error => {
                handleServerError(error)
                showMessageToast(error.data.message)
              }
            )
        },
        () => {
          // discard delete.
        }
      )
    }
    const camelToSnakeCase = str =>
      str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`)

    $scope.confirmUpdateUiSettings = (
      ev,
      edge,
      data,
      isBulkDeviceSelection = false
    ) => {
      const confirm = $mdDialog
        .confirm()
        .title($translate('cameraSettingWillBeOverwritten'))
        .textContent('')
        .ariaLabel($translate('settings'))
        .targetEvent(ev)
        .ok($translate('ok'))
        .cancel($translate('cancel'))

      $mdDialog.show(confirm).then(
        () => {
          if (isBulkDeviceSelection) {
            let dataV1 = {}
            var keyNames = Object.keys(data)
            keyNames.forEach(key => {
              switch (key) {
                case 'liveVideo':
                  dataV1['live_streaming_ui'] = data[key]
                  break
                case 'dateTimeUnits':
                  dataV1['date_time_mode'] = data[key]
                  break
                case 'standby':
                  dataV1['standby_trigger_minutes'] = data[key]
                  break
                case 'recordingEncryption':
                  dataV1.encrypt_recording = {
                    ...data[key],
                    value: data[key][recordingEncryptionField.valueFieldName]
                  }
                  delete dataV1.encrypt_recording[
                    recordingEncryptionField.valueFieldName
                  ]
                  break
                case 'driverIdentification':
                  dataV1[camelToSnakeCase(key)] = Object.keys(data[key]).reduce(
                    (obj, DIKeys) => {
                      return {
                        ...obj,
                        [camelToSnakeCase(DIKeys)]: data[key][DIKeys]
                      }
                    },
                    {}
                  )
                  break
                default:
                  dataV1[camelToSnakeCase(key)] = data[key]
              }
            })

            const message = {
              message_type: 'uiConfig',
              data: dataV1
            }
            const bulkRequestJson = {
              method: 'POST',
              url: `${DEVICEMANAGER_BASEURL}/v1.1/devices/bulk-message-per-selection`,
              data: {
                bulkDevicesSelections: getBulkDeviceSelections(),
                message
              },
              headers: {
                'x-request-time-ms': Date.now()
              }
            }
            $http(bulkRequestJson)
              .then(result => {
                if (result.data.status.code === 0) {
                  showMessageToast(
                    isBulkDeviceSelection
                      ? $translate('deviceBulkSettingsUpdated')
                      : $translate('deviceSettingsUpdated')
                  )
                } else {
                  handleServerError(result)
                  showMessageToast(result.data.status.error)
                }
              })
              .catch(ex => {
                if (ex.data && ex.data.status && ex.data.status.error) {
                  $scope.showMessageToast(ex.data.status.error)
                }
              })
          } else {
            edgeFactoryV2
              .updateDeviceSettings(edge.imei, data)
              .then(() => {
                showMessageToast($translate('deviceSettingsUpdated'))
              })
              .catch(error => {
                handleServerError(error)
                showMessageToast(error.data.message)
              })
          }
          clearSelectionData()
        },
        () => {
          // return to edge edit dialog
          if (!isBulkDeviceSelection) {
            $scope.showEditEdge(ev, edge)
          }
          clearSelectionData()
        }
      )
    }
    $scope.confirmPrivacyModeUpdate = (
      ev,
      data,
      isBulkDeviceSelection = false
    ) => {
      const { imei, privacyMode, privacySettings } = data
      const confirm = $mdDialog
        .confirm()
        .title($translate('cameraSettingWillBeOverwritten'))
        .textContent('')
        .ariaLabel($translate('settings'))
        .targetEvent(ev)
        .ok($translate('ok'))
        .cancel($translate('cancel'))

      $mdDialog.show(confirm).then(async () => {
        if (isBulkDeviceSelection) {
          let errorMessage = null
          const bulkSelections = getBulkDeviceSelections()
          if (privacySettings) {
            await edgeFactoryV2
              .updateDevicesPrivacySettingsV1(privacySettings, bulkSelections)
              .catch(error => {
                errorMessage = error.data.message || $translate('errorOccurred')
              })
          }
          if (privacyMode) {
            await edgeFactoryV2
              .updateDevicePrivacyModeSettingsV1(privacyMode, bulkSelections)
              .catch(error => {
                errorMessage = error.data.message || $translate('errorOccurred')
              })
          }
          if (errorMessage) {
            $scope.showMessageToast(errorMessage)
          } else {
            showMessageToast($translate('privacyModeSettingsUpdated'))
          }
        } else {
          let errorMessage = null
          if (privacySettings) {
            await edgeFactoryV2
              .updateDevicesPrivacySettings([imei], privacySettings)
              .then(response => {
                const data = response.data.data
                if (data.rejected && data.rejected.length > 0) {
                  errorMessage = data.rejected[0].reason
                }
              })
              .catch(error => {
                errorMessage = error.data.message || $translate('errorOccurred')
              })
          }
          if (privacyMode) {
            await edgeFactoryV2
              .updateDevicePrivacyModeSettings([imei], privacyMode)
              .then(response => {
                // if rejected then show error message
                const data = response.data.data
                if (data.rejected && data.rejected.length > 0) {
                  errorMessage = data.rejected[0].reason
                }
              })
              .catch(error => {
                errorMessage = error.data.message || $translate('errorOccurred')
              })
          }
          if (errorMessage) {
            $scope.showMessageToast(errorMessage)
          } else {
            showMessageToast($translate('privacyModeSettingsUpdated'))
          }
        }
        clearSelectionData()
      })
    }
    $scope.showEditEdge = (ev, edge) => {
      const deviceId = edge.imei
      $mdDialog
        .show({
          locals: {
            dataFromCaller: {
              edge_id: deviceId,
              edge: angular.copy(edge),
              whitelabel: $rootScope.data.whitelabel
            }
          },
          controller: 'EdgeEditController',
          templateUrl:
            './templates/edge.edit.view.html?t=' + window.webpackHash,
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true // Only for -xs, -sm breakpoints.
        })
        .then(
          //TODO: refactor it!!!!
          response => {
            if (response.type === 'delete') {
              $scope.confirmEdgeDelete(ev, deviceId)
              return
            }
            if (response.type === 'settings_changed') {
              $scope.confirmUpdateUiSettings(ev, response.edge, response.data)
              return
            }
            if (
              [
                'rma',
                'settings_unchanged',
                'privacy_settings_unchanged'
              ].includes(response.type)
            ) {
              if (response.message) {
                showMessageToast(response.message)
              }
              return
            }
            if (response.type === 'privacy_settings_changed') {
              $scope.confirmPrivacyModeUpdate(ev, response)
              return
            }
            const { groupId } = edge
            $scope.groupNavigation(groupId, 'current')
          },
          response => {
            if (
              response &&
              response.data &&
              response.data.requestResponse &&
              response.data.requestResponse.status
            ) {
              showMessageToast($translate('upgradeIsSentToDevice'))
            }
          }
        )
    }
    setTimeout(function () {
      fireRefreshEventOnWindow()
    }, 500)
    const showMessageToast = message => {
      const toast = $mdToast
        .simple()
        .textContent(message)
        .action($translate('ok'))
        .actionKey('F1')
        .position('top right')
        .hideDelay(5000)

      $mdToast
        .show(toast)
        .then(function (response) {
          if (response == 'ok') {
            // alert('You clicked the \'UNDO\' action.');
          }
        })
        .catch(() => {})
    }
    $scope.edgesMoved = async ({ id }, { imei, groupId }) => {
      const sourceGroupId = groupId
      const destinationGroupId = id
      if (sourceGroupId === destinationGroupId) {
        return
      }
      const requestJson = {
        method: 'PUT',
        url: `${EDGE_BASEURL}/device/${imei}/group/${destinationGroupId}`,
        data: {}
      }
      try {
        await $http(requestJson)
        $scope.groupNavigation(sourceGroupId, 'current')
        $scope.groupNavigation(destinationGroupId, 'current')
      } catch (error) {
        handleServerError(error)
      }
    }
    $scope.showEdgeOptions = (edge, edge_type, $event) => {
      $scope.showEditEdge($event, edge)
    }
    $scope.isEdgeBroadcastVideos = false
    $scope.broadcastViews = broadcastViewFactory.list
    $scope.getBroadcastViewById = id =>
      $filter('filter')(broadcastViewFactory.list, { id: id })[0]
    const loadBroadcastViews = async () => {
      const requestJson = {
        method: 'GET',
        url: `${BROADCAST_BASEURL}/organizationUserBroadcastViews/${$rootScope.currentUserOrganization.id}`
      }
      try {
        const response = await $http(requestJson)
        if (response.data.status.code == 0) {
          $scope.defaultView = false
          response.data.broadcastViews.forEach(function (broadcastView) {
            if (broadcastView.type === 1) {
              // $scope.openSideNav('multiple-braodcast-videos');
              $scope.defaultView = broadcastView
              $scope.showBroadcastView(broadcastView)
            }
            broadcastViewFactory.addOrUpdateItem(broadcastView)
          })
        }
      } catch (error) {
        handleServerError(error)
      }
    }
    $scope.deleteBroadcastView = (ev, broadcastViewID) => {
      const confirm = $mdDialog
        .confirm(ev)
        .title($translate('areYouSureYouWantToDeleteThisBroadcastView'))
        .textContent('')
        .ariaLabel($translate('deleteBroadcastView'))
        .targetEvent(ev)
        .ok($translate('delete'))
        .cancel($translate('cancel'))
      $mdDialog.show(confirm).then(
        async () => {
          const requestJson = {
            method: 'DELETE',
            url: BROADCAST_BASEURL + '/broadcastView/' + broadcastViewID
          }
          try {
            const response = await $http(requestJson)
            showMessageToast(response.data.status.error)
            if (response.data.status.code === 0) {
              broadcastViewFactory.deleteItemById(broadcastViewID)
            }
          } catch (error) {
            handleServerError(error)
          }
        },
        function () {
          // Cancel
        }
      )
    }
    $scope.broadcastViewId = ''
    $scope.showBroadcastView = broadcastView => {
      $scope.broadcastViewId = broadcastView.id
      $scope.isEdgeBroadcastVideos = false
      $scope.isNewBroadcastView = false
      var broadcastViewData = broadcastView.broadcastViewData
      $scope.$emit('broadcastViewRequest', {
        broadcastViewData: broadcastViewData,
        broadcastViewId: $scope.broadcastViewId
      })
      $scope.showMultipleBroadcastVideos(broadcastView.id)
    }
    $scope.isNewBroadcastView = true
    $scope.showMapMultipleBroadcasts = (broadcast, changeMapCenter = false) => {
      $scope.openSideNav('map-multiple-braodcast-videos')
      $scope.$emit('changeMapCenterEvent', {
        broadcast: broadcast,
        changeMapCenter: changeMapCenter
      })
    }
    $scope.broadcastsAdded = (edgeImei, streamId, open_sidepanel = false) => {
      const {
        item: { imei: serialNumber, name: cameraName }
      } = edgeFactoryV2.findItemByImei(edgeImei)
      const dashcamStream = {
        serialNumber,
        streamId,
        cameraName,
        amplitudeKey: AMPLITUDE_KEY,
        get translationsSrc () {
          return `./locale/lytx-live-video/${$translate1.use()}.json`
        }
      }
      $scope.$emit('dashcamStreamsAddedRequest', {
        dashcamStreams: [dashcamStream]
      })
    }
    $scope.$on('closeBroadcastViewRecieve', (e, data) => {
      if ($scope.currentState === 'home.common.maps.view') {
        $mdSidenav('map-multiple-braodcast-videos').close()
        if ($mdMedia('xs') || $mdMedia('sm')) {
          $mdSidenav('edge-list').open()
        }
      } else if ($scope.currentState === 'home.common.edge.list') {
        if ($mdMedia('xs') || $mdMedia('sm')) {
          $mdSidenav('multiple-braodcast-videos').close()
          $mdSidenav('edge-list').open()
        }
      }
    })
    $scope.showMultipleBroadcastVideos = (broadcastViewId = false) => {
      $scope.broadcastViewId = broadcastViewId
    }
    $scope.showEditEdgeGroup = (ev, groupId) => {
      $mdDialog
        .show({
          locals: {
            dataFromCaller: {
              edge_group_id: groupId,
              maxFirmwareversion: getMaxFirmwareversion()
            }
          },
          controller: 'EditEdgeGroupController',
          templateUrl:
            './templates/edgeGroup.edit.view.html?t=' + window.webpackHash,
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true // Only for -xs, -sm breakpoints.
        })
        .then(
          ({
            config: {
              data: { name, organizationId }
            },
            data: {
              status: { code, error }
            }
          }) => {
            showMessageToast(error)
            if (code === 0) {
              loadGroupDetails({ id: groupId, name, organizationId })
              loadEdgeGroups(true)
            }
          },
          function () {}
        )
    }
    $scope.confirmEdgeGroupDelete = (ev, groupId) => {
      // Appending dialog to document.body to cover sidenav in docs app
      var confirm = $mdDialog
        .confirm()
        .title($translate('areYouSureYouWantToDeleteThisEdgeGroup'))
        .textContent('')
        .ariaLabel($translate('deleteedgeGroup'))
        .targetEvent(ev)
        .ok($translate('delete'))
        .cancel($translate('cancel'))

      $mdDialog.show(confirm).then(
        function () {
          if (!$scope.edgeData && $localStorage.isResellerSso) {
            $scope.edgeData = {
              organizationId: $localStorage.currentUserOrganization.id
            }
          }
          var request_json = {
            method: 'DELETE',
            url: EDGE_BASEURL + '/edge_groups/' + groupId,
            data: $scope.edgeData
          }
          $http(request_json).then(
            function (response) {
              edgeGroupFactoryV2.deleteItemById(groupId)
              showMessageToast(response.data.status.error)

              // removing edges of edge group
              edgeFactoryV2.list
                .filter(e => e.groupId === groupId)
                .forEach(e => {
                  edgeFactoryV2.deleteItemById(e.id)
                })
              // refresh ungrouped edges
              $scope.groupNavigation(-1, 'current')
            },
            function (response) {
              handleServerError(response)
              showMessageToast(response.data.status.error)
            }
          )
        },
        function () {
          // discard delete.
        }
      )
    }

    const loadGroupDetails = data => edgeGroupFactoryV2.addOrUpdateItem(data)

    function handleServerError (response) {
      console.error(response)
      if (response && response.data) {
        if (response.data.statusCode == 401) {
          $scope.$emit('handleServerError', response)
        }
      } else {
        showMessageToast($translate('errorOccurred'))
      }
    }

    $scope.makeDefaultBroadCast = async userBroadcastView => {
      if (userBroadcastView.type == 1) {
        userBroadcastView.type = 0
      } else {
        userBroadcastView.type = 1
      }
      const requestJson = {
        method: 'PUT',
        url: BROADCAST_BASEURL + '/broadcastView/' + userBroadcastView.id,
        data: userBroadcastView
      }
      try {
        const response = await $http(requestJson)
        if (response.data.status.code === 0) {
          loadBroadcastViews()
        } else {
          showMessageToast(response.data.status.error)
        }
      } catch (error) {
        handleServerError(error)
      }
    }

    $scope.getCameraNameByStreamId = (edge, streamId) =>
      window.getCameraNameByStreamId($filter('translate'), edge, streamId)

    $scope.edegCollapse = async edge => {
      if ($mdMedia('xs') || $mdMedia('sm')) {
        $scope.$emit('sideStripToggle', {})
      }
      edge = edgeFactoryV2.findItemByImei(edge.imei).item
      edge.opened = !edge.opened
      edgeFactoryV2.list.forEach(e => {
        if (edge.imei !== e.imei) {
          e.opened = false
          e.selected = false
          edgeFactoryV2.addOrUpdateItem(e)
        }
      })
      edgeFactoryV2.addOrUpdateItem(edge)
      if ($state.current.name === 'home.common.maps.view') {
        $scope.$emit('mapEvent', { edge_id: edge.imei })
      }
      if ($state.current.name === 'home.common.edge.list') {
        if (edge.status !== DEVICE_STATUS.ONLINE) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(
                angular.element(document.querySelector('#popupContainer'))
              )
              .clickOutsideToClose(true)
              .title('')
              .textContent(
                $translate('liveVideoIsNotAvailableAsTheCameraIsOffline')
              )
              .ok($translate('ok'))
              .targetEvent()
          )
        } else {
          if (edge.status === DEVICE_STATUS.STANDBY) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(
                  angular.element(document.querySelector('#popupContainer'))
                )
                .clickOutsideToClose(true)
                .title('')
                .textContent($translate('liveVideoIsNotAvailableWhileStandby'))
                .ok($translate('ok'))
                .targetEvent()
            )
          } else {
            if (edge.opened && edge.status === DEVICE_STATUS.ONLINE) {
              edgeFactoryV2
                .getActiveCameras(edge.imei)
                .then(({ data }) => {
                  if (data.data) {
                    cameraIds = data.data.map(camera => camera.cameraId)
                    const foundEdge = edgeFactoryV2.list.find(
                      device => device.imei === edge.imei
                    )
                    if (foundEdge) {
                      foundEdge.onlineCameraIds = cameraIds
                    }
                  }
                })
                .catch(error => {
                  handleServerError(error)
                })
            }
          }
        }
      } else if ($state.$current.includes['home.common.recordings']) {
        if (
          edge.status !== DEVICE_STATUS.ONLINE &&
          edge.status !== DEVICE_STATUS.STANDBY
        ) {
          // offline
          edge.selected = false
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(
                angular.element(document.querySelector('#popupContainer'))
              )
              .clickOutsideToClose(true)
              .title('')
              .textContent(
                $translate('recordingsAreNotAvailableAsTheCameraIsOffline')
              )
              .ariaLabel(
                $translate('recordingsAreNotAvailableAsTheCameraIsOffline')
              )
              .ok($translate('ok'))
              .targetEvent()
          )
          $scope.showEdgeRecordings(edge)
        } else {
          edge.selected = true
          $scope.showEdgeRecordings(edge)
        }
        edgeFactoryV2.addOrUpdateItem(edge)
      } else if ($state.current.name == 'home.common.events') {
        $scope.showEdgeEventHistory(edge)
      } else if ($state.current.name == 'home.common.reports') {
        $scope.showEdgeReportHistory(edge)
      }
    }
    $scope.showEdgeEventHistory = ({ imei }) =>
      $state.go('home.common.events.history', { imei })
    $scope.showEdgeReportHistory = ({ imei }) => {
      $state.go('home.common.reports.edge', { imei })
    }
    $scope.showEdgeRecordings = edge => {
      edge.selected
        ? $state.go(
            browserInfo.name === 'Safari'
              ? 'home.common.recordings.list'
              : 'home.common.recordings.timeline',
            { imei: edge.imei }
          )
        : $state.go('home.common.recordings')
    }
    $scope.edge_gps_locations = {}
    $scope.getFullDateTime = t => new Date(t).toString()
    $scope.showEdgeEventSettings = (
      edge,
      ev = null,
      isBulkDeviceSelection = false
    ) => {
      $mdDialog
        .show({
          locals: {
            dataFromCaller: {
              edge,
              isBulkDeviceSelection,
              ...(isBulkDeviceSelection && {
                bulkDevicesSelections: getBulkDeviceSelections(),
                maxFirmwareVersion: getMaxFirmwareversion(),
                edge_list: $scope.edge_list
              })
            }
          },
          controller: 'EdgeEventSettingsController',
          templateUrl:
            './templates/edge.event.settings.view.html?t=' + window.webpackHash,
          // parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true // Only for -xs, -sm breakpoints.
        })
        .then(() => {
          clearSelectionData()
          showMessageToast($translate('eventsStatusUpdatedSucessfully'))
        })
        .catch(() => {})
    }
    $scope.showBulkDeviceUiSettings = ev => {
      $mdDialog
        .show({
          locals: {
            dataFromCaller: {
              selectedDevices:
                $scope.bulkDevicesSelectionsState.bulkDevicesSelections.devices
            }
          },
          controller: 'BulkDeviceUiSettingsEditController',
          templateUrl:
            './templates/bulk-device-ui-settings-edit.view.html?t=' +
            window.webpackHash,
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true // Only for -xs, -sm breakpoints.
        })
        .then(data => {
          if (data.type === 'privacy_settings_unchanged') {
            if (response.message) {
              showMessageToast(response.message)
            }
            return
          } else if (data.type === 'privacy_settings_changed') {
            $scope.confirmPrivacyModeUpdate(ev, data, true)
            return
          } else {
            $scope.confirmUpdateUiSettings(ev, null, data, true)
          }
        })
        .catch(() => {})
    }
    $scope.eventsvide_loading = false
    $scope.scrolllValue = true
    $scope.geofenceSettings = edge => {
      $scope.$emit('geofenceEvent', { edge_id: edge.id })
      $state.go('home.common.maps.geofence', { edge_id: edge.id })
    }
    $scope.stopPing = () => {
      $interval.cancel(statusTimer)
    }
    $scope.showGeofence = true
    $scope.showEdgeTrips = (ev, edge) => {
      $state.go('home.common.maps.edgeTrips', { edge_id: edge.imei })
    }
  }
])
